import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function rolePermissionReducer(state = initialState.rolePermissionData, action) {
  switch (action.type) {
    case types.LOAD_ROLE_PERMISSION_DATA_SUCCESS:
      return action.rolePermissionData;
    default:
      return state;
  }
}
